import { Berater } from './Berater';
import { BeraterBereiche } from './BeraterBereiche';
import { Beraterzuordnung } from './Beraterzuordnung';
import { ContextService } from '../../../services/context_service';
import { HWKListe } from './HWKListe';
import { IDs } from '../../../helpers/IDs';
import { Kontakte } from './Kontakte';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Registrierungen } from './Registrierungen';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { SchulungRegistrierung } from './SchulungRegistrierung';
import { MandantenBenutzer } from './MandantenBenutzer';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { Unternehmen } from './Unternehmen';
import { Verbaende } from './Verbaende';

interface UnternehmenTabsProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

interface UnternehmenTabsState {
    tabIndex: number;
}

export class UnternehmenTabs extends React.Component<UnternehmenTabsProps, UnternehmenTabsState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private disabled: string[] = ['kontakte', 'unternehmen'];
    private prefix: string = 'admin.tab.unternehmensdatenbank';
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_UNTERNEHMENSDATENBANK;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_KONTAKTE },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_UNTERNEHMEN },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_REGISTRIERUNGEN },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATER },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATER_WEITERE },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_BERATERZUORDNUNG },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_HWK_LISTE },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_VERBAENDE },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_SCHULUNG },
        { path: RoutingIDs.ROUTE_UNTERNEHMENSDATENBANK_MANDANTEN_BENUTZER }
    ];
    private tabs: string[] = [ // Reitereihenfolge beachten
        'kontakte', 'unternehmen', 'registrierungen', 'berater', 'berater', 'beraterzuordnung', 'hwk', 'verbaende',
        'schulungsveranstaltungen', 'mandanten_user'
    ];

    componentDidMount(): void {
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element {
        if (this.state.tabIndex === null) {
            return null;
        }

        return (
            <Tabs
                className='tabs-admin-unternehmensdatenbank'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    <Tab disabled={!this.rechte.kontakte}>Kontakte</Tab>
                    <Tab disabled={!this.rechte.unternehmen}>Unternehmen</Tab>
                    <Tab disabled={!this.rechte.registrierungen}>Registrierungen</Tab>
                    <Tab disabled={!this.rechte.berater}>Berater</Tab>
                    <Tab disabled={!this.rechte.berater}>Berater - Weitere Bereiche</Tab>
                    <Tab disabled={!this.rechte.beraterzuordnung}>Beraterzuordnung</Tab>
                    <Tab disabled={!this.rechte.hwk}>HWK-Liste / Einrichtungen</Tab>
                    <Tab disabled={!this.rechte.verbaende}>Verbände</Tab>
                    <Tab disabled={!this.rechte.schulungsveranstaltungen}>Schulungsveranstaltungen</Tab>
                    <Tab disabled={!this.rechte.mandanten_user}>Mandanten-Benutzer</Tab>
                </TabList>
                <TabPanel>
                    {this.rechte.kontakte &&
                        <Kontakte {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.unternehmen &&
                        <Unternehmen {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.registrierungen &&
                        <Registrierungen {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.berater &&
                        <Berater {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.berater &&
                        <BeraterBereiche {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.beraterzuordnung &&
                        <Beraterzuordnung {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.hwk &&
                        <HWKListe {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.verbaende &&
                        <Verbaende {...this.props} />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.schulungsveranstaltungen &&
                        <SchulungRegistrierung
                            onChange={() => this.triggerService.fire('admin_reload', IDs.ENT_REGISTRIERUNG)}
                        />
                    }
                </TabPanel>
                <TabPanel>
                    {this.rechte.mandanten_user &&
                        <MandantenBenutzer {...this.props} />
                    }
                </TabPanel>
            </Tabs>
        );
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }
}
